import {FCX} from "@datassential/platform-ui-lib";
import {useUserContext} from "@core/UserContext";
import {UnitType} from "@models";
import {Dispatch, memo, SetStateAction, useMemo} from "react";
import BreadCrumbs from "@components/BreadCrumbs";
import {Route} from "@core/routes/Route";
import SelectAmong from "@vms/SelectAmong";
import OutlinedTabs from "@vms/OutlinedTabs";
import {PiHash, PiPercent} from "react-icons/pi";
import cn from "classnames";

const AnalyzePerformanceNavHeader: FCX<{
    title: string;
    selectedUnit: UnitType;
    setSelectedUnit: Dispatch<SetStateAction<UnitType>>
}> = ({
    className,
    testId,
    title,
    selectedUnit,
    setSelectedUnit,
}) => {
    const {fullAccess} = useUserContext();

    const countRatingItems = useMemo(() => [
        {
            id: UnitType.Count,
            Icon: PiHash,
            title: 'Count',
        },
        {
            id: UnitType.Pct,
            Icon: PiPercent,
            title: 'Ratings',
        }
    ], [])

    return (
        <div
            className={
                cn(
                    "AnalyzePerformanceNavHeader",
                    className
                )
            }
            data-testid={testId}
        >
            <BreadCrumbs items={[
                {link: Route.Home, title: 'Home'},
                {link: '', title}
            ]}/>
            <div className="AnalyzePerformanceNavHeader__items">
                {fullAccess && selectedUnit === UnitType.Pct && (
                    <SelectAmong style={{color: "black", height: "100%"}}/>
                )}
                <OutlinedTabs
                    selected={selectedUnit}
                    setSelected={setSelectedUnit}
                    items={countRatingItems}
                />
            </div>
        </div>
    )
}

export default memo(AnalyzePerformanceNavHeader);